import { render } from "./Legal.vue?vue&type=template&id=eb234c2e&ts=true"
import script from "./Legal.vue?vue&type=script&lang=ts"
export * from "./Legal.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__